module.exports = __webpack_public_path__ + "static/media/38-9.472cdab0.mp3";